import {
	readLoomPersonalizationInputs,
	type LoomPersonalizationResult,
} from '@confluence/loom-utils/entry-points/loomPersonalization.ts';

import type { ViewPagePersonalizationResult } from './preloadViewPagePersonalization.ts';

/** Keep Loom's error and fallback policy separate from other parent-query consumers. */
export function readViewPageLoomPersonalization(
	result: ViewPagePersonalizationResult,
): LoomPersonalizationResult {
	if (!result || (result.status === 'loaded' && !result.variables.includeLoom)) return undefined;
	if (result.status === 'failed' || !result.data.loom) return { retryLegacy: true };
	try {
		return readLoomPersonalizationInputs(
			result.data.loom,
			result.errors.some(({ path }) =>
				['confluence_loomEntryPoints', 'loom_settings', 'loom_connectedCalendars'].includes(
					String(path?.[0]),
				),
			),
		);
	} catch {
		return { retryLegacy: true };
	}
}
